export default "__VITE_ASSET__D3xm$Rq$__"